import { PlatformPlan } from "Generated/graphql-types"

const config = { domain: 'Account', subdomain: 'Upgrade' }

interface UpgradeClicked {
  slug: string
  platformPlan: PlatformPlan | null
}

interface ContinueStarterClicked {
  slug: string
}

interface CtaClicked { }

interface ContactAdminClicked {
  plan: string
}

export const upgrade = {
  Upgrade_Clicked: {
    Upgrade_Clicked: (param: UpgradeClicked) => param,
    config,
  },

  Continue_Starter_Clicked: {
    Continue_Starter_Clicked: (param: ContinueStarterClicked) => param,
    config,
  },

  CTA_Clicked: {
    CTA_Clicked: (param: CtaClicked) => param,
    config,
  },

  Button_Clicked: {
    Button_Clicked: (param: CtaClicked) => param,
    config,
  },

  Contact_Admin_Clicked: {
    Contact_Admin_Clicked: (param: ContactAdminClicked) => param,
    config,
  },

  Get_Sponsored_Clicked: {
    Get_Sponsored_Clicked: (param: CtaClicked) => param,
    config,
  },

  Select_Plan_Clicked: {
    Select_Plan_Clicked: (param: CtaClicked) => param,
    config,
  },

  Modal_Viewed: {
    Modal_Viewed: (param: CtaClicked) => param,
    config,
  },
}
